import styled from "@emotion/styled";
import { useState } from "react";
import { useEffect } from "react";
import { FaPlay } from "react-icons/fa";
import { HelpVideoAPI } from "../api/HelpVideoAPI";
import Loading from "./Loading";

const VideoPreview = styled.div`
  width: 640px;
  height: 360px;

  background-color: #666666;

  display: flex;
  justify-content: center;
  align-items: center;
`;

interface Props {
  contextTag?: string;
  urlForPreview?: string;
  defaultVideoUrl?: string;
}

export function HelpVideo(props: Props) {
  const { contextTag, urlForPreview, defaultVideoUrl } = props;
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [hasVideo, setHasVideo] = useState(true);

  useEffect(() => {
    if (defaultVideoUrl) {
      setVideoUrl(defaultVideoUrl);
      return;
    }

    (async () => {
      let videoUrl = await HelpVideoAPI.getVideoFromContext(contextTag);
      setVideoUrl(videoUrl);
      if (!videoUrl) {
        setHasVideo(false);
      }
    })();
  }, []);

  return (
    <div
      style={{
        marginTop: 25,
        borderRadius: 20,
        overflow: "hidden",
        background: "#666",
        height: 360,
      }}
    >
      <VideoPreview style={{ position: "relative" }}>
        {(videoUrl || urlForPreview) && (
          <iframe
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 5,
            }}
            allowTransparency={true}
            src={urlForPreview || videoUrl}
            width="640"
            height="360"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
        {hasVideo ? <Loading /> : <FaPlay color="white" size={32} />}
      </VideoPreview>
    </div>
  );
}
